import CryptoJS from 'crypto-js'; 

export const crypt = (value) => {
  return CryptoJS.AES.encrypt(value, 'LT?LfSaefSAH6d8').toString()
};
